
<div *ngIf="instances?.length === 1">
  <nb-form-field style="margin: 10px 0;" *ngIf="selectedInstances?.[0]">
    <label>{{item.label || ROLE}}<span >*</span></label>
    <nb-select [formControl]="selectedInstances[0].role" placeholder="Role" (selectedChange)="update(selectedInstances[0].role)" ngDefaultControl fullWidth="true">
      <nb-option *ngFor="let role of instances[0].roles" [value]="role.name">{{role.title}}</nb-option>
    </nb-select>
  </nb-form-field>
</div>
<div *ngIf="instances?.length > 1">
<h3>Instances Access:</h3>
<div>
  <div class="flex-row"
  style="align-items: center;padding: 5px;">
  <div class="flex-column-1"><label>Product</label></div>
  <div class="flex-column-3"><label>Role</label></div>
  <div class="flex-column-1"><label></label></div>
</div>
<div *ngFor="let instance of instances; let i = index">
  <div *ngIf="selectedInstances?.[i]?.can_add" class="flex-row"
    style="align-items: center;padding: 5px;">
    <div class="flex-column-1">
      <nb-checkbox [formControl]="selectedInstances[i].active"
          (change)="update(selectedInstances[i].active)" ngDefaultControl> <label>{{formatType(instance.scaffold_type)}}</label></nb-checkbox>
    </div>
    <div class="flex-column-3" style="min-height: 35px;">
      <nb-form-field *ngIf="selectedInstances?.[i]?.active?.value === true">
        <nb-select [formControl]="selectedInstances[i].role" placeholder="Role"
          (selectedChange)="update(selectedInstances[0].role)" ngDefaultControl fullWidth="true">
          <nb-option *ngFor="let role of instance.roles" [value]="role.name">{{role.title}}</nb-option>
        </nb-select>
      </nb-form-field>
    </div>
    <div class="flex-column-1">
      <button nbButton status="primary" [disabled]="selectedInstances[i].updating" (click)="updateInstances(i)"
        *ngIf="((selectedInstances[i].role.dirty || selectedInstances[i].active.dirty) && selectedInstances[i].role.value)">Update</button>
    </div> 
    <hr>
  </div>
 
</div>

</div>